import type {AppDispatch} from 'stores/redux_store';

import {type ActionFunc} from 'mattermost-redux/types/actions';
import {type PostWithMeta} from 'features/posts/types/posted_event';
import {getProfilesAndGroupsForPosts} from 'mattermost-redux/actions/posts';

import {handleNewPosts} from './handle_new_posts';
import {getUserStatusesForPosts} from './get_user_statuses_for_posts';
import {setOnlineStatusForNewPostCreators} from './set_online_status_for_new_post_creators';

export const handlePostedEvents = (payload: PostWithMeta[]): ActionFunc =>
    async (doDispatch) => {
        const dispatch = doDispatch as AppDispatch;

        const posts = payload.map(({post}) => post);

        try {
            dispatch(setOnlineStatusForNewPostCreators(payload));
            dispatch(getUserStatusesForPosts(posts));
            dispatch(getProfilesAndGroupsForPosts(posts));
            await dispatch(handleNewPosts(payload));
        } catch (error) {
            return {data: false, error};
        }

        return {data: true};
    };

